import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import _ from "lodash";
import { withRouter } from "react-router";
import { Radio, Input, Button, Select, Row, Col, Spin } from "antd";
import * as Yup from "yup";
import fire from "./fire";
import "antd/dist/antd.css";
import ConfirmationPopup from "./ConfirmationPopup";
import {
  getEntryAndTargetPricesFromValues,
  extendValidTill,
} from "./helper/helper";
import { FormSelect } from "./formComponents/FormSelect";
import { FormDatePicker } from "./formComponents/FormDatePicker";
const { Option } = Select;
const errorStyle = {
  color: "red",
};

const adviseContainerStyle = {
  display: "flex",
  background: "rgba(255,255,255)",
  margin: "auto",
  padding: 10,
  border: "2px black",
  borderRadius: 5,
  boxShadow: "4px 4px 6px 0px rgba(50, 50, 50, 0.3)",
  maxWidth: 600,
  flexDirection: "column",
};

const UpdateAdvise = (props) => {
  //props.location.state contains advise data so that users cant open update page from anywhere else
  const [oldComments, setOldComments] = useState([]);
  const [adviseHistory, setHistory] = useState([]);
  const [enableCustomDate, setCustomDate] = useState(false);
  const [currentStatus, setCurrentStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const adviseId = props.location.state.detail.adviseId;
  const adviseStatus = props.location.state.detail.status;
  const currentAdvisoryType = props.location.state.detail.advisoryType;
  const currentValidTill = props.location.state.detail.validTill;
  const currentEntryPriceFrom = props.location.state.detail.entryPriceFrom;
  const currentEntryPriceTo = props.location.state.detail.entryPriceTo;
  const currentTargetPriceFrom = props.location.state.detail.targetPriceFrom;
  const currentTargetPriceTo = props.location.state.detail.targetPriceTo;
  const currentSlPrice = props.location.state.detail.slPrice;
  const currentPositionType = props.location.state.detail.positionType;
  const userRole = props.location.state.role;
  const currentQuickTradeType = props.location.state.detail?.quickTradeType
    ? props.location.state.detail?.quickTradeType
    : null;
  const currentExpiry = props.location.state.detail?.expiry
    ? props.location.state.detail?.expiry
    : null;

  let db = fire.firestore();

  useEffect(() => {
    checkLogin();
    getCurrentData();
  }, []);

  const checkLogin = () => {
    fire.auth().onAuthStateChanged(function (user) {
      if (user && props.location.state) {
        // User is signed in.
      } else {
        // No user is signed in.
        props.history.push("/phone-login");
      }
    });
  };

  const updateSchema = Yup.object().shape({
    entryPriceFrom: Yup.number()
      .positive("Enter a positive number")
      .required("required"),
    entryPriceTo: Yup.number()
      .positive("Enter a positive number")
      .required("required"),
    targetPriceFrom: Yup.number()
      .positive("Enter a positive number")
      .required("required"),
    targetPriceTo: Yup.number()
      .positive("Enter a positive number")
      .required("required"),
    slPrice: Yup.number()
      .positive("Enter a positive number")
      .required("required"),
    status: Yup.string().required("required"),
    comments: Yup.string().required("required"),
    positionType: Yup.string().required("required"),
  });

  const getCurrentData = async () => {
    const commentSnapshot = await db.collection("advises").doc(adviseId).get();
    setOldComments(commentSnapshot.data().comments);
    setHistory(commentSnapshot.data().history || []);
    setCurrentStatus(commentSnapshot.data().status);
    // console.log(commentSnapshot.data());
    return [];
  };

  const backToDashboard = () => {
    props.history.push("/");
  };

  const checkStatus = async () => {
    const statusRef = await db.collection("advises").doc(adviseId).get();
    return (await statusRef.data().status) === adviseStatus;
  };

  const add = (values, setSubmitting) => {
    setIsLoading(true);
    const currentDate = new Date().getTime();
    let commentObject = {};
    if (values.comments) {
      commentObject.message = values.comments;
      commentObject.timestamp = currentDate;
      commentObject.status = values.status;
    }
    let historyObject = values;
    historyObject.timestamp = currentDate;
    values = getEntryAndTargetPricesFromValues(values);
    setOldComments(oldComments.push(commentObject));

    setHistory(adviseHistory.push(historyObject));
    values = {
      ...values,
      updatedAt: currentDate,
      comments: oldComments,
      history: adviseHistory,
    };

    db.collection("advises")
      .doc(adviseId)
      .update(values)
      .then(function (docRef) {
        setTimeout(() => {
          setIsLoading(false);
          setSubmitting(false);
          props.history.push("/");
        }, 2000);
      })
      .catch(function (error) {
        console.error("Error adding document: ", error);
      });
  };

  const handleQuickTradeExpiryChange = (
    event,
    values,
    handleChange,
    setFieldValue
  ) => {
    handleChange(event);
    if (event.target.value === "equity") {
      setFieldValue("expiry", "na");
    }
    if (event.target.value === "futures") {
      setFieldValue("expiry", "month");
      // values.expiry = "na";
    }
  };
  // const disableSubmitButton = () => {
  //   // console.log("user", userRole == "admin");
  //   if (isSubmitting) return true;
  //   if (userRole == "admin") return false;
  //   else return true;
  // };
  return isLoading ? (
    <div className="adviseContainer">
      <Spin />
    </div>
  ) : (
    <section>
      <div className="adviseContainer" style={adviseContainerStyle}>
        <div
          style={{
            display: "flex",
            padding: 5,
            justifyContent: "space-between",
          }}
        >
          <Button
            type="ghost"
            shape="round"
            icon="left"
            onClick={backToDashboard}
          />
          <h2>
            <span>
              update
              <span style={{ fontWeight: 800, marginRight: 85 }}>advise.</span>
            </span>
          </h2>
        </div>
        <Formik
          initialValues={
            currentQuickTradeType
              ? {
                  status: adviseStatus,
                  comments: "",
                  entryPriceFrom: currentEntryPriceFrom,
                  entryPriceTo: currentEntryPriceTo,
                  targetPriceFrom: currentTargetPriceFrom,
                  targetPriceTo: currentTargetPriceTo,
                  slPrice: currentSlPrice,
                  positionType: currentPositionType,
                  quickTradeType: currentQuickTradeType,
                  expiry: currentExpiry,
                }
              : {
                  status: adviseStatus,
                  comments: "",
                  entryPriceFrom: currentEntryPriceFrom,
                  entryPriceTo: currentEntryPriceTo,
                  targetPriceFrom: currentTargetPriceFrom,
                  targetPriceTo: currentTargetPriceTo,
                  slPrice: currentSlPrice,
                  positionType: currentPositionType,
                }
          }
          validationSchema={updateSchema}
          onSubmit={async (values, { setSubmitting }) => {
            setSubmitting(true);
            // only run add if status is the same
            if (await checkStatus()) {
              add(values, setSubmitting);
            } else {
              window.alert("Status of the advise changed !!");
              setSubmitting(false);
              props.history.push("/");
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            setFieldTouched,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit}>
              <Row>
                <Col style={{ margin: "5px 0px", padding: "5" }} span={24}>
                  <label> Status</label>
                  <FormSelect
                    className="formInput"
                    name="status"
                    onChange={(value) => setFieldValue("status", value)}
                    value={values.status}
                    defaultValue="MANUAL AVOID"
                    role={userRole}
                  />
                  <span style={errorStyle}>
                    {errors.status && touched.status && errors.status}
                  </span>
                </Col>
                {userRole === "admin" ||
                (userRole === "advisor" && adviseStatus !== "Activated") ? (
                  <>
                    {currentQuickTradeType ? (
                      <Col style={{ margin: "5px 0px" }} span={24}>
                        <label>Trade Type</label>
                        <div>
                          <Radio.Group
                            defaultValue="equity"
                            buttonStyle="solid"
                            name="quickTradeType"
                            onChange={(event) => {
                              handleQuickTradeExpiryChange(
                                event,
                                values,
                                handleChange,
                                setFieldValue
                              );
                            }}
                            onBlur={handleBlur}
                            value={values.quickTradeType}
                          >
                            <Radio.Button value="equity">Equity</Radio.Button>
                            <Radio.Button value="options">Option</Radio.Button>
                            <Radio.Button value="futures">Future</Radio.Button>
                          </Radio.Group>
                        </div>
                        <span style={errorStyle}>
                          {errors.quickTradeType &&
                            touched.quickTradeType &&
                            errors.quickTradeType}
                        </span>
                      </Col>
                    ) : null}
                    {values.quickTradeType === "options" ? (
                      <Col style={{ margin: "5px 0px" }} span={24}>
                        <label>Option Expiry Type</label>
                        <div>
                          <Radio.Group
                            buttonStyle="solid"
                            name="expiry"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.expiry}
                          >
                            <Radio.Button value="month">Month</Radio.Button>
                            <Radio.Button value="week">Week</Radio.Button>
                          </Radio.Group>
                        </div>
                        <span style={errorStyle}>
                          {errors.expiry && touched.expiry && errors.expiry}
                        </span>
                      </Col>
                    ) : null}
                    <Col style={{ margin: "5px 0px" }} span={24}>
                      <label>Entry Price</label>
                    </Col>
                    <Col style={{ margin: "auto" }} span={12}>
                      <Input
                        className="formInput"
                        name="entryPriceFrom"
                        type="number"
                        min="0"
                        placeholder="Minimum"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.entryPriceFrom}
                        step="any"
                      />
                      <span style={errorStyle}>
                        {errors.entryPriceFrom &&
                          touched.entryPriceFrom &&
                          errors.entryPriceFrom}
                      </span>
                    </Col>
                    <Col style={{ margin: "auto" }} span={12}>
                      <Input
                        className="formInput"
                        name="entryPriceTo"
                        type="number"
                        min="0"
                        placeholder="Maximum"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.entryPriceTo}
                        step="any"
                      />
                      <span style={errorStyle}>
                        {errors.entryPriceTo &&
                          touched.entryPriceTo &&
                          errors.entryPriceTo}
                      </span>
                    </Col>
                    <Col style={{ margin: "5px 0px" }} span={24}>
                      <label>Target Price</label>
                    </Col>
                    <Col style={{ margin: "auto" }} span={12}>
                      <Input
                        className="formInput"
                        name="targetPriceFrom"
                        type="number"
                        min="0"
                        placeholder="Minimum"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.targetPriceFrom}
                        step="any"
                      />
                      <span style={errorStyle}>
                        {errors.targetPriceFrom &&
                          touched.targetPriceFrom &&
                          errors.targetPriceFrom}
                      </span>
                    </Col>
                    <Col style={{ margin: "auto" }} span={12}>
                      <Input
                        className="formInput"
                        name="targetPriceTo"
                        type="number"
                        min="0"
                        placeholder="Maximum"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.targetPriceTo}
                        step="any"
                      />
                      <span style={errorStyle}>
                        {errors.targetPriceTo &&
                          touched.targetPriceTo &&
                          errors.targetPriceTo}
                      </span>
                    </Col>
                    <Col style={{ margin: "5px 0px" }} span={24}>
                      <label>Stop Loss Price</label>
                      <Input
                        className="formInput"
                        name="slPrice"
                        type="number"
                        min="0"
                        placeholder="Stop Lose Price"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.slPrice}
                        step="any"
                      />
                      <span style={errorStyle}>
                        {errors.slPrice && touched.slPrice && errors.slPrice}
                      </span>
                    </Col>
                  </>
                ) : (
                  <div />
                )}
                {adviseStatus === "Activated" &&
                currentAdvisoryType !== "INTRADAY" ? (
                  <>
                    <Col style={{ margin: "5px 0px", padding: "5" }} span={24}>
                      <label>Extend Expiry</label>
                      <Select
                        className="formInput"
                        name="advisoryType"
                        onChange={(value) => {
                          setFieldValue("advisoryType", value);
                          if (value !== "More Than 3 Months")
                            setFieldValue("validTill", extendValidTill(value,currentValidTill));
                          else {
                            setCustomDate(true);
                            setFieldValue("validTill");
                          }
                        }}
                        value={values.advisoryType}
                      >
                        <Option value="BTST">1 Day</Option>
                        <Option value="2-3 Days">3 Days</Option>
                        <Option value="1-Week">1-Week</Option>
                        <Option value="2-Weeks">2-Weeks</Option>
                        <Option value="3-Weeks">3-Weeks</Option>
                        <Option value="1-Month">1-Month</Option>
                        <Option value="3-Months">3-Months</Option>
                        <Option value="More Than 3 Months">
                          More Than 3 Months
                        </Option>
                      </Select>
                      <span style={errorStyle}>
                        {errors.advisoryType &&
                          touched.advisoryType &&
                          errors.advisoryType}
                      </span>
                    </Col>
                    <Col style={{ margin: "5px 0px" }} span={24}>
                      <FormDatePicker
                        className="formInput"
                        style={{ width: "100%" }}
                        advisoryType={values.advisoryType}
                        showTime
                        onChange={(value, dateString) => {
                          return setFieldValue(
                            "validTill",
                            value.toDate().getTime()
                          );
                        }}
                        enableCustomDate={enableCustomDate}
                        setFieldValue={setFieldValue}
                        validTill={props.validTill}
                      />
                    </Col>
                  </>
                ) : null}
                <Col style={{ margin: "5px 0px" }} span={24}>
                  <label>Comments</label>
                  <Input.TextArea
                    className="formInput"
                    name="comments"
                    placeholder="Comments"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.comments}
                  />
                  <span style={errorStyle}>
                    {errors.comments && touched.comments && errors.comments}
                  </span>
                </Col>
                <Col span={24} style={{ marginTop: 15 }}>
                  <ConfirmationPopup
                    loading={isSubmitting}
                    disabled={
                      isSubmitting //state
                    }
                    values={values}
                    errors={errors}
                    touched={touched}
                    title="Update Advise"
                  />
                </Col>
              </Row>
            </form>
          )}
        </Formik>
      </div>
    </section>
  );
};
export default withRouter(UpdateAdvise);
